import {
  BasicButton,
  Modal,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@certn/cascadia-react";
import type { components } from "@certn/api/generated-schemas/client-portal";
import { Trans, useTranslation } from "react-i18next";

type SubsidiaryChangeModalProps = {
  data: components["schemas"]["SubsidiaryChangeRequiredResponse"];
  onCancel: () => void;
  onConfirm: () => void;
};
export const SubsidiaryChangeModal = ({
  data,
  onCancel,
  onConfirm,
}: SubsidiaryChangeModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen testID="subsidiary-change-confirmation-modal">
      <Dialog>
        <>
          <DialogHeader onClose={onCancel}>
            {t("Currency change required")}
          </DialogHeader>
          <DialogContent>
            <Stack gap="space-4">
              <Text style="global/body-primary">
                <Trans
                  i18nKey="The country you selected requires a change to your billing currency from <bold>{{currentCurrency}}</bold> to <bold>{{newCurrency}}</bold>."
                  values={{
                    currentCurrency: data.current_currency,
                    newCurrency: data.new_currency,
                  }}
                  components={{ bold: <strong /> }}
                />
              </Text>
              {data.payment_profiles_to_archive.length > 0 && (
                <>
                  <Text style="global/body-primary">
                    {t(
                      "This will also remove the following payment profile(s). You will need to add a new payment profile after this change."
                    )}
                  </Text>
                  <ul style={{ margin: 0, paddingLeft: "var(--space-5)" }}>
                    {data.payment_profiles_to_archive.map((pp) => (
                      <li key={pp.id}>
                        <Text style="global/body-primary">
                          <strong>
                            {pp.title ||
                              `${pp.brand ?? ""} ${t("ending in")} ${pp.last4 ?? "****"}`}
                          </strong>
                          {pp.expiry_date &&
                            ` (${t("Expires")} ${pp.expiry_date})`}
                        </Text>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </Stack>
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={onCancel}>{t("Cancel")}</BasicButton>
            <PrimaryButton onPress={onConfirm}>{t("Confirm")}</PrimaryButton>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
};
